export default __webpack_public_path__ + "static/media/kiosk-ticket-scan.dcd0304f.gif";